module.exports = __webpack_public_path__ + "media/components/documents/images/taxReturnForms/1065-7710797f90fd8555e1d4e2dd0d01fae4.png";